<template>
  <v-app>
    <nuxt-layout>
      <nuxt-page />
    </nuxt-layout>
    <toast-snackbar-queue />
    <client-only>
      <ChatWidget />
    </client-only>
  </v-app>
</template>

<script setup lang="ts">
import { ChatWidget } from '~/chat-widget'

const localSettings = useLocalSettings();

const colorSchemeQueryList = window.matchMedia('(prefers-color-scheme: dark)');
const systemThemeIsDark = ref<boolean>(colorSchemeQueryList.matches);
useEventListener(colorSchemeQueryList, 'change', (event: MediaQueryListEvent) => {
  systemThemeIsDark.value = event.matches;
});

const vuetifyTheme = useTheme();
const themeName = computed(() => {
  let theme = localSettings.theme;
  if (!theme || !['light', 'dark'].includes(theme)) {
    // Use system theme
    if (systemThemeIsDark.value) {
      theme = 'dark';
    } else {
      theme = 'light';
    }
  }
  return theme;
});
watch(themeName, () => {
  const isDark = themeName.value.toLowerCase().includes('dark');
  document.documentElement.style.setProperty('color-scheme', isDark ? 'dark' : 'light');
  document.documentElement.classList.toggle('dark', isDark);
  vuetifyTheme.change(themeName.value);
}, { immediate: true });
</script>
